import Route from '@ember/routing/route';
import { get } from '@ember/object';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import dateValidation from '../../../../../../validations/contact-date';

export default Route.extend({
  abilities: service(),
  fundsService: service(),
  store: service(),
  navbarSettings: service(),

  beforeModel(transition) {
    if (this.abilities.noAbility('edit_contact')) {
      transition.abort();
    }
    return this.fundsService.confirmValidFundToken();
  },

  model(params) {
    let contact = get(this.modelFor('funds.fund.contacts.contact'), 'contact');
    if (params.dateId === 'add') {
      let record = this.store.createRecord('contact-date', {
        contactId: get(contact, 'id'),
      });
      return {
        contact: contact,
        record: record,
        changeset: new Changeset(
          record,
          lookupValidator(dateValidation),
          dateValidation,
        ),
      };
    } else {
      return this.store.findRecord('contact-date', params.dateId).then((record) => {
        return {
          contact: contact,
          record: record,
          changeset: new Changeset(
            record,
            lookupValidator(dateValidation),
            dateValidation,
          ),
        };
      });
    }
  },
});
